import React, { useEffect, useState } from 'react';
import axios from 'axios';

const ReactionGameLeaderboard = () => {
  const [scores, setScores] = useState([]);

  useEffect(() => {
    axios.get('/api/scores/leaderboard')
      .then((res) => setScores(res.data))
      .catch((err) => console.error(err));
  }, []);

  return (
    <div className="leaderboard">
      <h2>Leaderboard</h2>
      <ul>
        {scores.map((score, index) => (
          <li key={index}>
            {index + 1}. {score.userName}: {score.score} points
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ReactionGameLeaderboard;
